import { apiClient } from './api';

const analyticsService = {
  // Get cooked dishes analytics data
  getCookedDishesAnalytics: async () => {
    try {
      const response = await apiClient.get('/api/v1/analytics/cooked');
      return response;
    } catch (error) {
      console.error('Error fetching cooked dishes analytics:', error);
      throw error;
    }
  },

  // Get overview analytics data
  getOverviewAnalytics: async () => {
    try {
      const response = await apiClient.get('/api/v1/analytics/overview');
      return response;
    } catch (error) {
      console.error('Error fetching overview analytics:', error);
      throw error;
    }
  }
};

export default analyticsService;